/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Inherited_Link_TeamInputs */

const en_settings_inherited_link_team = /** @type {(inputs: Settings_Inherited_Link_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`team`)
};

const de_settings_inherited_link_team = /** @type {(inputs: Settings_Inherited_Link_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

/**
* | output |
* | --- |
* | "team" |
*
* @param {Settings_Inherited_Link_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_inherited_link_team = /** @type {((inputs?: Settings_Inherited_Link_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Inherited_Link_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_inherited_link_team(inputs)
	return de_settings_inherited_link_team(inputs)
});